/**
 * Login App Entry Point
 *
 * Separate entry point for the login page.
 * This is loaded only on the login route, keeping the main app bundle smaller.
 */

import '@/lib/i18n';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { Loader2 } from 'lucide-react';
import { LoginPage } from '@/components/login';
import { BootReady } from '@/components/BootReady';
import { applyPrimaryColorToDocument } from '@/lib/primary-color';
import './styles.css';

// Get login data from PHP
const loginData = window.dddLoginData;

if (!loginData) {
	console.error('DDD Login: Missing login data from PHP');
}

applyPrimaryColorToDocument();

// Render login app
const root = document.getElementById('ddd-login-root');

if (root) {
	ReactDOM.createRoot(root).render(
		<React.StrictMode>
			<BootReady />
			<Suspense
				fallback={
					<div className="min-h-screen flex items-center justify-center">
						<Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
					</div>
				}
			>
				<LoginPage
					redirectTo={loginData?.redirectTo || '/'}
					companyLogo={loginData?.companyLogo}
					companyName={loginData?.companyName}
				/>
			</Suspense>
		</React.StrictMode>
	);
} else {
	console.error('DDD Login: Root element #ddd-login-root not found');
}
